import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './index.css';

const DataList = props => {
  const { data, theme } = props;
  const dataCSS = cn(
    'datalist',
    theme ? theme.map(css => `datalist--${css}`).join(' ') : ''
  );

  const renderData = (line, idx) => (
    <Fragment key={idx}>
      <dt>{line.label}</dt>
      {line.delivery}
      {line.lines &&
        line.lines.map((line, i) => (
          <dd key={`${idx}-${i}`}>
            {line.content}
            {line.unit && (
              <span className={'datalist__unit'}>
                {line.output && <output>{line.output}</output>}
                {line.unit}
              </span>
            )}
          </dd>
        ))}
    </Fragment>
  );

  return data && data.length ? (
    <dl className={dataCSS}>{data && data.map(renderData)}</dl>
  ) : null;
};

DataList.propTypes = {
  data: PropTypes.array.isRequired,
  theme: PropTypes.array,
};

export default DataList;



// WEBPACK FOOTER //
// ./src/common/components/DataList/index.js